import { useState, useEffect, useCallback, KeyboardEventHandler } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '@ui/hooks/useStore';
import { demoConfig } from '@config/demo.config';
import { IState } from './IState';

const useAuth = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, lang, app, modal } = useStore();

    const initState: IState = {
        toConfrimPage: false,
        passRecoveryVisible: false,
    };
    const [state, setState] = useState(initState);

    const handleAuthenticationOpen = useCallback(() => {
        modal.openAuthentication();
    }, []);
    const handleAuthenticationClose = useCallback(() => {
        modal.closeModal();
    }, []);
    const handleDemoClick = useCallback(() => {
        const { login, password } = demoConfig;
        setState((prev) => ({
            ...prev,
            toConfrimPage: true,
        }));
        user.login(login, password);
        app.setDemoMode();
    }, []);
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = useCallback(
        (e) => {
            const { key } = e;
            if (key === 'Enter') {
                e.stopPropagation();
                e.preventDefault();
                const target = e.target as HTMLElement;
                target.click();
            }
        },
        [],
    );
    const handlers = {
        handleAuthenticationOpen,
        handleAuthenticationClose,
        handleDemoClick,
        handleBtnKeyDown,
    };

    useEffect(() => {
        user.resetAuthError();
        user.resetRegisterError();
        user.resetServerError();
    }, []);

    useEffect(() => {
        if (user.email && !user.token && state.toConfrimPage) {
            const search = new URLSearchParams(location.search);
            navigate(`/confirm?${search.toString()}`);
        }
    }, [user.email]);

    return {
        lang,
        app,
        modal,
        handlers,
    };
};

export default useAuth;
